<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="prefixes">

          <template slot="header" vs-justify="flex-end">
            <router-link :to="{name: 'master-prefix-add'}" >
                <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" v-if="pms ('MasterPrefix', 'create', 'b')"></vs-button>
            </router-link>
          </template>

          <template slot="thead">
            <vs-th sort-key="nameTh" class="w-4/12">{{ $t("sections.master.dataForm.nameTh") }}</vs-th>
            <vs-th sort-key="nameEn" class="w-5/12">{{ $t("sections.master.dataForm.nameEn") }}</vs-th>
            <vs-th sort-key="status" class="w-1/12">{{ $t("sections.master.dataForm.status") }}</vs-th>
            <vs-th sort-key="default" class="w-1/12">{{ $t("sections.master.dataForm.default") }}</vs-th>
            <vs-th sort-key="#" class="w-1/12"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.nameTh">
                {{ tr.nameTh }}
              </vs-td>
              <vs-td :data="tr.nameEn">
                {{ tr.nameEn }}
              </vs-td>
              <vs-td :data="tr.status">
                <vs-chip :color="getStatusColor(tr.status)">{{ tr.status }}</vs-chip>
              </vs-td>
              <vs-td :data="tr.isChoose">
                <vs-switch color="success" v-model="isChoose" :vs-value="tr.id" icon-pack="feather" vs-icon="icon-check" />
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <router-link :to="{ name: 'master-prefix-edit', params: {id: tr.id } }" >
                    <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="pms ('MasterPrefix', 'edit', 'b')"></vs-button>
                  </router-link>
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" v-if="pms ('MasterPrefix', 'delete', 'b')" @click="del();actionID=tr.id" ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  async created () {
    const vm = this
    const { getPrefixes } = vm;
    await getPrefixes()
    vm.pms ('MasterPrefix', 'visible', 'r')
    const obj = vm.prefixes.find(res => res.isChoose === true)
    vm.isChoose = ( obj ? [obj.id] : [])
    vm.tableName = 'prefix'
  },
  computed: {
    ...mapMasterFields(['prefixes', 'status']),
  },
  methods: {
    ...mapMasterActions(['getPrefixes', 'deletePrefix']),
    async del () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDel
      })
    },
    async acceptDel () {
      await this.deletePrefix({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
